import { connect } from 'react-redux';
import { createStructuredSelector } from 'reselect';
import { getLocale } from '../../selectors/language';
import component from './component';

export const mapStateToProps = createStructuredSelector({
  locale: getLocale,
});

export const enhance = connect(mapStateToProps, null);

export default enhance(component);
